import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n}{suffix}
    </span>
  );
};

export const Stats = ({ stats }) => (
  <section className="relative overflow-hidden gradient-bg-2 noise-overlay" data-testid="stats-section">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-14">
        {stats.map((s, i) => (
          <div key={i} data-testid={`stat-${i}`} className="text-white">
            <div className="font-display font-black text-5xl md:text-7xl leading-none tracking-tighter">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <div className="mt-4 h-px w-12 bg-white/50" />
            <p className="mt-4 text-sm uppercase tracking-[0.15em] text-white/80 font-semibold">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
